import { TOGGLE_HAMBURGER_MENU } from "./type";

export const toggleHamburgerMenu = (status: boolean) => {
  return {
    type: TOGGLE_HAMBURGER_MENU,
    status
  };
};
